import colors from '@magoosh/lib/styles/colors.module.scss';

export default (examName: string, sections: string) => {
  if (examName === 'GMAT') {
    const quantTypes = [
      {
        label: 'Pure Contexts',
        percentage: true,
        value: 100
      },
      {
        label: 'Real Contexts',
        percentage: true,
        value: 100
      }
    ];

    const verbalTypes = [
      {
        label: 'Critical Reasoning',
        percentage: true,
        value: 100
      },
      {
        label: 'Reading Comprehen...',
        percentage: true,
        value: 100
      }
    ];

    const dataInsightsTypes = [
      {
        label: 'Data Sufficiency',
        percentage: true,
        value: 100
      },
      {
        label: 'Integrated Reasoning',
        percentage: true,
        value: 100
      }
    ];

    if (!sections || sections === 'all') {
      return [
        { name: 'Quantitative Reasoning', data: quantTypes },
        { name: 'Verbal Reasoning', data: verbalTypes },
        { name: 'Data Insights', data: dataInsightsTypes }
      ];
    }

    let result = [];

    if (sections.indexOf('quantitative_reasoning') !== -1){
      result.push({ name: 'Quantitative Reasoning', data: quantTypes });
    }
    if (sections.indexOf('verbal_reasoning') !== -1) {
      result.push({ name: 'Verbal Reasoning', data: verbalTypes });
    }
    if (sections.indexOf('data_insights') !== -1) {
      result.push({ name: 'Data Insights', data: dataInsightsTypes });
    }

    return result;
  } else if (examName === 'GRE') {
    const mathTypes = [
      {
        label: 'Data Interpretation',
        percentage: true,
        value: 100
      },
      {
        label: 'Multiple Answer',
        percentage: true,
        value: 100
      },
      {
        label: 'Multiple Choice',
        percentage: true,
        value: 100
      },
      {
        label: 'Numeric Entry',
        percentage: true,
        value: 100
      },
      {
        label: 'Quantitative Comp...',
        percentage: true,
        value: 100
      }
    ];

    const verbalTypes = [
      {
        label: 'Reading Comprehen...',
        percentage: true,
        value: 100
      },
      {
        label: 'Sentence Equivalence',
        percentage: true,
        value: 100
      },
      {
        label: 'Text Completion',
        percentage: true,
        value: 100
      }
    ];

    const writingTypes = [
     {
        label: 'Usse Task (Graded)',
        range: { low: 0, high: 6 },
        value: 6
      },
    ];

    if (!sections || sections === 'all') {
      return [
        { name: 'Math', data: mathTypes },
        { name: 'Verbal', data: verbalTypes },
        { name: 'Writing', data: writingTypes }
      ];
    }

    let result = [];

    if (sections.indexOf('math') !== -1){
      result.push({ name: 'Math', data: mathTypes });
    }
    if (sections.indexOf('verbal') !== -1) {
      result.push({ name: 'Verbal', data: verbalTypes });
    }
    if (sections.indexOf('writing') !== -1) {
      result.push({ name: 'Writing', data: writingTypes });
    }

    return result;
  } else {
    return [];
  }
};
